<template>
  <loading
    :active.sync="isDashLoading"
    :can-cancel="false"
    :color="'#f18f00'"
    :is-full-page="false"
    :height="100"
    :width="255"
    :opacity="0.8"
    class="custom-loading-dash"
  >
  </loading>
</template>
<script>
export default {
  name: 'loading-component',
  props: {
    isDashLoading: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
